export function getdata(){
	var obj = {
			headData: [{
				title: "环境保护税",
				children: [{
					title: "序号",
					prop: "groud",
					custom: true,
				}, {
					title: "税源编号",
					prop: "ccxwhb_1_x_1",
					
					custom: true,
				}, {
					title: "污染物类别",
					prop: "ccxwhb_1_x_2",
					
					custom: true,
				}, {
					title: "污染物名称",
					prop: "ccxwhb_1_x_3",
					
					custom: true,
				}, {
					title: "税款所属期起",
					prop: "ccxwhb_1_x_4",
					
					custom: true,
				}, {
					title: "税款所属期止",
					prop: "ccxwhb_1_x_5",
					
					custom: true,
				}, {
					title: "减免性质代码和项目名称",
					prop: "ccxwhb_1_x_6",
					
					custom: true,
				}, {
					title: "减免税额",
					prop: "ccxwhb_1_x_7",
					
					custom: true,
				}]
			}],
			tableDataII_I: [{
				groud: 1,
				disabledccxwhb_1_x_1: false,
				disabledccxwhb_1_x_2: false,
				disabledccxwhb_1_x_3: false,
				disabledccxwhb_1_x_4: false,
				disabledccxwhb_1_x_5: false,
				disabledccxwhb_1_x_6: false,
				disabledccxwhb_1_x_7: false,
				ccxwhb_1_x_1: {
					cellCode: "ccxwhb_1_i1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_2: {
					cellCode: "ccxwhb_1_i1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_3: {
					cellCode: "ccxwhb_1_i1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_4: {
					cellCode: "ccxwhb_1_i1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_5: {
					cellCode: "ccxwhb_1_i1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_6: {
					cellCode: "ccxwhb_1_i1_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_7: {
					cellCode: "ccxwhb_1_i1_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				groud: 2,
				disabledccxwhb_1_x_1: false,
				disabledccxwhb_1_x_2: false,
				disabledccxwhb_1_x_3: false,
				disabledccxwhb_1_x_4: false,
				disabledccxwhb_1_x_5: false,
				disabledccxwhb_1_x_6: false,
				disabledccxwhb_1_x_7: false,
				ccxwhb_1_x_1: {
					cellCode: "ccxwhb_1_i2_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_2: {
					cellCode: "ccxwhb_1_i2_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_3: {
					cellCode: "ccxwhb_1_i2_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_4: {
					cellCode: "ccxwhb_1_i2_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_5: {
					cellCode: "ccxwhb_1_i2_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_6: {
					cellCode: "ccxwhb_1_i2_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_7: {
					cellCode: "ccxwhb_1_i2_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}, {
				groud: '小计',
				disabledccxwhb_1_x_1: false,
				disabledccxwhb_1_x_2: false,
				disabledccxwhb_1_x_3: false,
				disabledccxwhb_1_x_4: false,
				disabledccxwhb_1_x_5: false,
				disabledccxwhb_1_x_6: false,
				disabledccxwhb_1_x_7: false,
				ccxwhb_1_x_1: {
					cellCode: "ccxwhb_1_i3_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_2: {
					cellCode: "ccxwhb_1_i3_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_3: {
					cellCode: "ccxwhb_1_i3_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_4: {
					cellCode: "ccxwhb_1_i3_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_5: {
					cellCode: "ccxwhb_1_i3_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_6: {
					cellCode: "ccxwhb_1_i3_6",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwhb_1_x_7: {
					cellCode: "ccxwhb_1_i3_7",
					cellType: "1",
					cellVal: "240040043.08"
				},
			}],
	}
	return obj
}
